import { CarvanaTheme } from '@carvana/showroom-theme';
import styled from 'styled-components';

export const Title = styled.div`
  font-weight: bold;
  font-size: 24px;
  text-transform: uppercase;
  margin: 0 0 15px;
  padding: 0 19px;
  line-height: 1.2;

  @media (min-width: ${CarvanaTheme.breakpoint.md}px) {
    margin: 0 0 14px;
    font-size: 28px;
    line-height: 1.5;
  }
`;

export const SubTitle = styled.div`
  text-align: center;
  color: ${CarvanaTheme.color.neutral.v500};
  margin: 0 0 30px;
  font-size: 16px;
  padding: 0 1px;

  @media (min-width: ${CarvanaTheme.breakpoint.md}px) {
    font-size: 21px;
    padding: 0 35px;
  }
`;

export const CtaWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-flow: column;
  flex-wrap: nowrap;
  width: 100%;
  justify-content: center;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    flex-flow: row;
  }
`;

export const NoResultsWrapper = styled.div.attrs({
  'data-qa': 'no-results-wrapper'
})`
  text-align: center;
  margin: 40px 0;
  padding: 0 12px;
  width: 100%;

  @media (min-width: ${CarvanaTheme.breakpoint.md}px) {
    margin: 50px 0;
    padding: 0 32px;
  }
`;
